function s(e, t) {
  const o = Object.keys(e);
  if (typeof t == "string") {
    const n = o.filter((r) => r.startsWith(`${t}.`));
    return e[t] || n.some((r) => e[r]) || !1;
  }
  return o.some((n) => e[n]);
}
export {
  s as getStatus
};
